import React from "react";
import { VisualizationType, registeredVisualizations } from "@redash/viz/lib";
import classNames from "classnames";
import { useTheme } from "@/components/ThemeProvider";

import "./VisualizationName.less";

function VisualizationName({ visualization }) {
  const { isDarkMode } = useTheme();
  const config = registeredVisualizations[visualization.type];
  
  const className = classNames("visualization-name", {
    "dark-mode": isDarkMode
  });

  return (
    <span className={className}>
      {config && visualization.name !== config.name ? visualization.name : null}
    </span>
  );
}

VisualizationName.propTypes = {
  visualization: VisualizationType.isRequired,
};

export default VisualizationName;
